const MODEL_NAME = 'drainage'

export default [
  {
    path: `/${MODEL_NAME}/instruct`,
    name: 'instruct',
    component: () =>
      import(/* webpackChunkName: "instruct" */ '@pages/drainageActivity/instruct/index.vue')
  },
  {
    path: `/${MODEL_NAME}/instruct/detail`,
    name: 'instructDetail',
    component: () =>
      import(
        /* webpackChunkName: "instruct-detail" */ '@pages/drainageActivity/instructDetail/index.vue'
      )
  },
  {
    path: `/${MODEL_NAME}/instruct/tip`,
    name: 'instructTip',
    component: () =>
      import(
        /* webpackChunkName: "instruct-detail" */ '@pages/drainageActivity/instructTip/index.vue'
      )
  },
  {
    path: `/${MODEL_NAME}/instruct/image`,
    name: 'instructImage',
    component: () =>
      import(
        /* webpackChunkName: "instruct-detail" */ '@pages/drainageActivity/instructImage/index.vue'
      )
  }
]
